import request from '@/utils/request.js';

// 日志或者报表控制器
export function GetEnterpriseExpenseInfoPageList(data) {
    // 获取最新的公司充值数据或者坐席新增数据
    return request({
        url: '/Finance/GetEnterpriseExpenseInfoPageList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function UpdateEnterpriseOrSeatInfo(data) {
    // 公司消费和充值分页列表
    return request({
        url: '/Finance/UpdateEnterpriseOrSeatInfo',
        method: 'post',
        data,
        apiType: 'java'
    });
}
